export default __webpack_public_path__ + "9f5ad9347c30b9c12152b5c84b63e5b5.png";